import { BenchmarkDetails } from "@/components/BenchmarkDetails";
import { Credit } from "@/components/Credit";

export default function About() {
  return (
    <section className="max-w-3xl mx-auto px-4 sm:px-6 pt-16 pb-24">
      <h1 className="text-4xl font-bold mb-6">About TalentAlign</h1>
      <div className="prose prose-invert max-w-none text-slate-300 leading-relaxed space-y-4 mb-10">
        <p>
          TalentAlign is an AI-native, ML-grounded, evidence-first resume
          matching engine. It is designed both as a standalone product and as a
          white-label platform that other HR tech companies can drop into their
          own offerings.
        </p>
        <p>
          The scoring engine combines seven independent signals — semantic
          similarity, keyword overlap, bullet-level alignment, section-level
          alignment, title family recognition, seniority band, and field/domain
          fit — fused with learned weights. Every score traces back to specific
          resume bullets and job description requirements, so every decision is
          defensible.
        </p>
        <p>
          The AI layer is powered by OpenRouter, giving access to 200+ models
          from every major provider — OpenAI GPT-4o, Anthropic Claude, Google
          Gemini, Meta Llama, Mistral, and more — through a single unified
          gateway. Swap between state-of-the-art commercial models and
          open-source alternatives with one click. Ollama is supported for
          compliance customers who need fully offline inference.
        </p>
        <p>
          Bias audit is built in from day one. The PII mask pipeline runs
          every match twice — once with names, schools, and pronouns visible,
          once with them stripped — and surfaces the score delta. Recruiters
          can export a bias audit PDF as a compliance artifact.
        </p>
      </div>

      <h2 className="text-2xl font-bold mb-4 text-slate-100">
        Validated accuracy
      </h2>
      <p className="text-sm text-slate-400 leading-relaxed mb-5">
        Marketing claims are cheap. The TalentAlign scoring engine is
        regression-gated in continuous integration against a labeled benchmark
        dataset — every code change is measured and the build fails if ranking
        quality drops below a floor. Current numbers:
      </p>

      <BenchmarkDetails />

      <div className="mt-12 pt-8 border-t border-slate-800/60">
        <Credit tier={3} className="text-slate-300" />
      </div>
    </section>
  );
}
